import React from "react";
import { BreadcrumbItem } from "reactstrap";
import { Route, Switch, Link } from "react-router-dom";
import * as Section from "@repoflow/components/section";
import * as ListRoute from "./list";

// Flatter than the limits section next door, and deliberately so: captures are
// read-only here (they arrive from services holding an api key) and have no
// stable single-row address to link to, so there is no `new`, no `:captureId`
// and no entity route — only the one screen.
//
// LABELLED "Statistics" AND ADDRESSED `/capture`, since 2026-08-13. Nothing on
// the screen is a capture ROW any more — the listing left it the day after the
// charts arrived — so what it draws is an aggregate over the captures rather
// than the captures themselves. The label is what bucketws calls its equivalent,
// and the point page links to it as "Go to Statistics...".
//
// The URL is NOT renamed to match, which bucketws did do. The difference is that
// bucketws' section was new; this one has been `/capture` since the captures
// read shipped, it is what docs/datum-captures.md documents and what the e2e
// navigates to directly. A path is an address other things hold, and renaming it
// buys a word.
const LocalProvider = ({ match: { params }, children: Children }) => {
  const parent = Section.useSectionContext();
  const { base: parentBase, basepath: parentBasepath, schema } = parent;
  const base = `${parentBase}/capture`;
  const basepath = `${parentBasepath}/capture`;

  return (
    <Section.Provider
      schema={[...schema]}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, parent })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath }) => (
        <Switch>
          <Route path={`${basepath}/`} component={ListRoute.Content} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath }) => (
        <>
          <BreadcrumbItem>
            <Link to={`${base}`}>Statistics</Link>
          </BreadcrumbItem>

          <Switch>
            <Route path={`${basepath}/`} component={ListRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => <>
</>;
